import { pick } from "lodash-es";
import * as generalActionTypes from "../../actions/GeneralActions/generalActionTypes";
import { sendReduxAnalyticsEvent } from "./analyticsHandler";

function handleAction(action) {
    let event;

    // If it's not a primitive Redux action, ignore it (might be a promise or undefined, if a function was dispatched)
    if (!action?.type) return;

    if (action.type === generalActionTypes.LOCATION_CHANGE) {
        event = {
            action: "GoToPage",
            label: action.path,
            title: document.title,
        };
    }
    if (event) sendReduxAnalyticsEvent(pick(event, ["action", "legacy_category", "label"]));
}

const analyticsMiddleware = () => next => action => {
    handleAction(action);
    return next(action);
};

export default analyticsMiddleware;
